import { useState } from "react"
import { Box, Popover, Stack, Typography } from "@mui/material"
import { Repeat } from "lib/@components/repeat"
import { navigate } from "lib/routes/navigate"
import Iconify from "minimals-template/components/Iconify"
import { SkillMapRateCardLink } from "./skill-map-rate-card-link"

export function SkillMapRateCardCell({ rateCards }) {
    const [popoverAnchor, setPopoverAnchor] = useState(null)

    if (rateCards.length === 0) {
        return (
            <Typography variant="body2" color="text.secondary">
                —
            </Typography>
        )
    }

    if (rateCards.length === 1) {
        return (
            <Box
                sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 0,
                    cursor: "pointer",
                    "&:hover .rc-name": { textDecoration: "underline" },
                }}
                onClick={goToRateCard}
            >
                <Iconify
                    icon="solar:user-id-broken"
                    width={20}
                    height={20}
                    sx={{ color: "text.primary", flexShrink: 0, mr: 1 }}
                />
                <Typography className="rc-name" variant="body2" sx={{ color: "text.primary" }} noWrap>
                    {rateCards[0].name}
                </Typography>
            </Box>
        )
    }

    return (
        <>
            <Box
                sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 0,
                    cursor: "pointer",
                    "&:hover .rc-name": { textDecoration: "underline" },
                }}
                onClick={openPopover}
            >
                <Iconify
                    icon="solar:user-id-broken"
                    width={20}
                    height={20}
                    sx={{ color: "text.primary", flexShrink: 0, mr: 1 }}
                />
                <Typography className="rc-name" variant="body2" sx={{ color: "text.primary" }}>
                    {rateCards.length} rate cards
                </Typography>
            </Box>
            <Popover
                open={Boolean(popoverAnchor)}
                anchorEl={popoverAnchor}
                onClose={closePopover}
                anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                transformOrigin={{ vertical: "top", horizontal: "left" }}
                slotProps={{ paper: { sx: { p: 1, minWidth: 180 } } }}
            >
                <Stack spacing={0}>
                    <Repeat list={rateCards} item={<SkillMapRateCardLink />} />
                </Stack>
            </Popover>
        </>
    )

    function goToRateCard(e) {
        e.stopPropagation()
        navigate(`/app/optimiser/rate-cards/${rateCards[0].id}`)
    }

    function openPopover(e) {
        e.stopPropagation()
        setPopoverAnchor(e.currentTarget)
    }

    function closePopover(e) {
        if (e) e.stopPropagation()
        setPopoverAnchor(null)
    }
}
